<template>
  <span class="icon_close" :style="`width: ${width}px; height: ${height}px;`" />
</template>

<script>
export default {
  name: 'IconCloseImg',
  props: {
    width: {
      type: Number,
      default: 56
    },
    height: {
      type: Number,
      default: 56
    }
  }
}
</script>

<style lang="scss" scoped>
.icon_close {
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background: url(~@/assets/images/loginRetain/icon_close_default.png) no-repeat;
  background-size: cover;
  &:hover { background-image: url(~@/assets/images/loginRetain/icon_close_hover.png) }
  &:active { background-image: url(~@/assets/images/loginRetain/icon_close_active.png) }
}
</style>
